<template>
  <div class="commerce-home">
    <div v-if="business && commerce">
      <MainBackButton />

      <div
        v-if="width > 700 && width < 1050"
        class="iframe-wrapper smartphone-bg"
      >
        <p>
          <i class="fa fa-arrows-alt-h fa-lg" />
          <br />Increase screen width to<br />to view live preview
        </p>
      </div>

      <div v-if="width >= 1050" class="iframe-wrapper">
        <div class="preview-btn">
          <i
            class="fa fa-laptop fa-sm"
            style="margin-right: 6px"
            @click="showDesktopPreview = true"
          />
          Live Preview
          <i
            class="fa fa-redo fa-sm"
            style="margin-left: 6px"
            @click="f += 1"
          />
        </div>
        <iframe class="shop-profile" :src="shopURL" :key="f"></iframe>
      </div>

      <div
        v-if="showDesktopPreview"
        class="iframe-wrapper desktop-preview"
        @click="showDesktopPreview = false"
      >
        <div class="preview-btn">
          Desktop Preview
          <button class="delete is-small" style="margin-top: 3px" />
        </div>
        <iframe
          class="shop-profile"
          :src="shopURL"
          :key="f"
          tabindex="0"
          @click.stop
          @keydown.esc="showDesktopPreview = false"
        ></iframe>
      </div>

      <div
        v-if="isScrollTop"
        class="top-bar"
        :style="themeBgColor"
        @click="scrollToTop"
      >
        <p class="no-scrollbar" :style="themeColor">
          {{ business.name }}
          <span style="display: inline-block; width: 40px" />
        </p>
      </div>

      <div
        ref="scrollable"
        class="wrapper no-scrollbar"
        v-on:scroll.passive="onScroll"
        @touchmove="scrollPos = 1"
        @touchend="onScroll"
      >
        <div v-if="!scrollPos" class="alerts">
          <!-- <span
            class="button is-dark shadow is-rounded"
            style="padding: 10px"
            @click="openCommerceManagerAlerts"
          >
            <i class="far fa-bell" />
          </span> -->
          <span
            class="button is-dark shadow is-rounded"
            style="padding: 10px"
            @click="goto('profile')"
          >
            <i class="far fa-user" />
          </span>
        </div>

        <section
          class="hero has-bg-img"
          :class="{ tile: bannerStyle === 'tile' }"
          v-webp:bg="bannerPicURL"
          @click="goto('/commerce_page/shop-appearance')"
        >
          <div class="hero-body"></div>
          <div class="gradient">
            <p class="business-name">{{ business.name }}</p>
          </div>
        </section>

        <img
          v-if="profilePic"
          class="profile-pic"
          :class="{ 'pp-high': scrollPos }"
          :src="profilePic"
          @click="goto('/commerce_page/shop-appearance')"
        />

        <div class="welcome" :style="`${themeBgColor}; ${themeColor}`">
          <p style="max-width: calc(100vw - 100px); margin-bottom: 8px">
            <span style="font-size: 1.15em">
              Welcome
              <span v-if="userName" @click="goto('profile')">
                <span class="link">{{ userName }}</span
                >,</span
              >
              <span v-else class="link has-text-info" @click="setName"
                >please enter your name</span
              >
            </span>
          </p>
          <div v-if="unnamedShop">
            <p style="font-size: 1.1em; font-weight: 500">
              What is your shop's name?
              <!-- &nbsp;<span class="tag skip" @click="skipName">Skip</span> -->
            </p>
            <div class="field is-grouped" style="margin-top: 8px">
              <div class="control is-expanded">
                <input
                  class="input is-medium is-success pulse-input"
                  v-model="shopName"
                  :placeholder="'Shop Name'"
                />
              </div>
              <div class="control">
                <span v-if="updatingShopName" class="button is-medium">
                  <i class="fa fa-spinner fa-spin" />
                </span>
                <span v-else class="button is-medium" @click="saveShopName"
                  >Save</span
                >
              </div>
            </div>
          </div>
          <div v-else>
            Your shop is currently
            <span class="hours link" @click="openHours">
              <span v-if="isOpen" class="has-text-success">open</span>
              <span v-else-if="isPaused" class="has-text-orange">paused</span>
              <span v-else-if="closedUntil" class="has-text-danger">{{
                closedUntilString
              }}</span>
              <span v-else class="has-text-danger">closed</span>
            </span>
          </div>
        </div>

        <div v-if="business.is_active">
          <CommerceHomeOrderSummary />
        </div>
        <div v-else-if="showTutorial">
          <div class="divider" />
          <div class="row tutorial">
            <p style="font-size: 1.1em; color: #aaa; margin-bottom: 8px">
              See how easy it is to start selling
              <!-- <span
                class="tag is-rounded has-text-grey is-pulled-right"
                @click="skipTutorial"
                >Skip</span
              > -->
              <button
                class="delete is-medium is-pulled-right"
                @click="skipTutorial"
              />
            </p>

            <div
              class="button is-full-width is-success is-outlined"
              @click="goto(`/shop/${businessID}`)"
            >
              <p class="has-text-dark">
                <span class="tutorial-icon">1</span> Make a test order
                <i class="fa fa-chevron-right" />
              </p>
            </div>
            <div
              class="button is-full-width is-success is-outlined"
              @click="goto('/commerce_page/menu-product-list')"
            >
              <p class="has-text-dark">
                <span class="tutorial-icon">2</span> Edit your menu
                <i class="fa fa-chevron-right" />
              </p>
            </div>
            <div
              class="button is-full-width is-success is-outlined"
              @click="goto('/commerce_page/shop-appearance')"
            >
              <p class="has-text-dark">
                <span class="tutorial-icon">3</span> Change shop appearance
                <i class="fa fa-chevron-right" />
              </p>
            </div>
            <div
              class="button is-full-width is-success is-outlined"
              @click="goto('/commerce_page/business-info')"
            >
              <p class="has-text-dark">
                <span class="tutorial-icon">4</span> Edit your business info
                <i class="fa fa-chevron-right" />
              </p>
            </div>
            <div
              class="button is-full-width is-success is-outlined"
              @click="goto('/commerce_page/staff')"
            >
              <p class="has-text-dark">
                <span class="tutorial-icon">5</span> Add staff to shop
                <i class="fa fa-chevron-right" />
              </p>
            </div>

            <!-- <p>
              <span class="tutorial-icon">1</span>
              Make and process an order
            </p>
            <div
              class="button is-success is-outlined"
              @click="goto(`/shop/${businessID}`)"
            >
              <p>
                Make a test order
                <i class="fa fa-chevron-right" />
              </p>
            </div>
            <p>
              <span class="tutorial-icon">2</span>
              Edit your menu / product list
            </p>
            <div
              class="button is-success is-outlined"
              @click="goto('/commerce_page/menu-product-list')"
            >
              <p>
                Edit menu / product list
                <i class="fa fa-chevron-right" />
              </p>
            </div>
            <p>
              <span class="tutorial-icon">3</span>
              Change your shop appearance
            </p>
            <div
              class="button is-success is-outlined"
              @click="goto('/commerce_page/shop-appearance')"
            >
              <p>
                Change shop appearance
                <i class="fa fa-chevron-right" />
              </p>
            </div>
            <p>
              <span class="tutorial-icon">4</span>
              Edit your business info
            </p>
            <div
              class="button is-success is-outlined"
              @click="goto('/commerce_page/business-info')"
            >
              <p>
                Edit business info
                <i class="fa fa-chevron-right" />
              </p>
            </div>
            <p>
              <span class="tutorial-icon">5</span>
              Add staff to shop
            </p>
            <div
              class="button is-success is-outlined"
              @click="goto('/commerce_page/staff')"
            >
              <p>
                Add staff
                <i class="fa fa-chevron-right" />
              </p>
            </div> -->
          </div>
        </div>

        <div v-if="!business.is_active">
          <div class="divider" />

          <div class="row" @click="goto('/commerce_page/go-live')">
            <i class="fa fa-umbrella-beach icon has-text-primary" />In Test Mode
            <span class="is-pulled-right">
              Go Live
              <i class="fa fa-chevron-right has-text-primary icon" />
            </span>
          </div>
        </div>

        <div v-for="s in filteredSections" :key="s.name">
          <div class="divider" />

          <div class="row" @click="goto(`/commerce_page/${s.name}`)">
            <i class="icon" :class="s.icon" />{{
              $t(`commerce-page-name.${s.name}`)
            }}
            <i
              v-if="superOnly.includes(s.name)"
              class="icon fab fa-superpowers is-pulled-right"
              style="opacity: 0.5"
            />
          </div>
        </div>

        <!-- <div class="divider" />

        <div class="row" @click="goto('/commerce_page/examples-and-tutorials')">
          <i class="fa fa-play-circle icon" />Examples and Tutorials
        </div> ---->

        <!--------------------- END OF LIST  ---------------------->

        <div class="app-version">
          App Version {{ $store.state.version }}
          <span class="link is-pulled-right" @click="forceUpdateApp"
            >Update App</span
          >
        </div>

        <footer class="bottom is-flex no-scrollbar">
          <div
            v-if="hasMultipleShops"
            class="column"
            @click="goto(`/commerce_page/change-shop`)"
          >
            <i class="fa fa-exchange-alt" />
            <p>{{ $t("change") }}</p>
          </div>
          <div class="column" @click="goto('ecommerce')">
            <i class="fa fa-th-list" />
            <p>{{ $t("Orders") }}</p>
          </div>
          <div class="column" @click="viewShop">
            <i class="fa fa-store-alt" />
            <p>{{ $t("Shop") }}</p>
          </div>
          <div class="column" @click="triggerDelivery">
            <i class="fa fa-shipping-fast" />
            <p :class="{ 'has-text-grey': hideTukExpress }">
              {{ $t("Express") }}
            </p>
          </div>
          <!-- <div class="column" @click="goto('profile')">
            <i class="far fa-user" />
            <p>{{ $t("Profile") }}</p>
          </div> -->
        </footer>

        <div
          v-if="showDeleted"
          class="deleted-bg"
          @click="showDeletedBtn = false"
        >
          <div class="deleted-btn">
            <i>{{ $t("Deleted Business") }}</i>
          </div>
        </div>
      </div>
    </div>

    <div v-else-if="loading">
      <CommerceHomeSkeleton />
    </div>

    <div v-else class="notification has-text-centered">
      <i class="fa fa-user-secret" />
      <p class="subtitle has-text-grey">{{ $t("commerce.not-allowed") }}</p>
      <a class="button is-success" style="margin-top: 10px" @click="goHome">
        Go Home
      </a>
    </div>
  </div>
</template>


<script>
import MainBackButton from "@/components/MainBackButton";
import CommerceHomeSkeleton from "@/components/CommerceHomeSkeleton";
import CommerceHomeOrderSummary from "@/components/CommerceHomeOrderSummary";

export default {
  name: "CommerceHome",
  components: {
    MainBackButton,
    CommerceHomeSkeleton,
    CommerceHomeOrderSummary,
  },
  props: {
    id: String, // businessID
  },
  data() {
    return {
      business: null,
      z: 0,
      f: 0, // iframe key
      shopName: null,
      updatingShopName: false,
      showDesktopPreview: false,
      showTutorial: true,
      loading: false,
      isScrollTop: false,
      scrollPos: 0,
      editImageType: null, // banner or profile
      showDeletedBtn: true,
      superOnly: [
        "examples-and-tutorials",
        "change-shop",
        "promotions-and-marketing",
        "links-qr-codes-and-assets",
        "staff",
        "fulfilment-options",
        "payment-options",
        "analytics",
        "billing",
        "help-and-faq",
        "superuser",
      ],
      sections: [
        {
          name: "examples-and-tutorials",
          icon: "fa fa-play-circle",
        },
        // {
        //   name: "change-shop",
        //   icon: "fa fa-exchange-alt",
        // },
        { name: "business-info", icon: "fa fa-info-circle" },
        { name: "shop-appearance", icon: "fa fa-store-alt" },
        { name: "menu-product-list", icon: "fa fa-list" },
        {
          name: "promotions-and-marketing",
          icon: "fa fa-tags",
        },
        {
          name: "links-qr-codes-and-assets",
          icon: "fa fa-share-alt",
        },
        {
          // name: "custom-app-and-whitelabel",
          name: "apps-and-platforms",
          icon: "fa fa-mobile-alt",
        },
        {
          name: "members-and-loyalty",
          icon: "far fa-address-card",
        },
        { name: "staff", icon: "fa fa-users" },
        {
          name: "fulfilment-options",
          icon: "fa fa-play-circle",
        },
        {
          name: "payment-options",
          icon: "fa fa-coins",
        },
        {
          name: "tuk-express",
          icon: "fa fa-motorcycle",
        },
        {
          name: "analytics",
          icon: "fa fa-chart-line",
        },
        {
          name: "billing",
          icon: "fa fa-file-invoice",
        },
        {
          name: "help-and-faq",
          icon: "far fa-question-circle",
        },
        {
          name: "tuk-support",
          icon: "fa fa-headset",
        },
        { name: "superuser", icon: "fa fa-mask" },
      ],
    };
  },
  computed: {
    unnamedShop() {
      if (!this.business.name) return true;
      return this.business.name.endsWith("'s Shop*");
    },
    width() {
      return this.$store.state.width;
    },
    shopURL() {
      return `${process.env.VUE_APP_HOST}/shop/${this.business.id}`;
    },
    hideSections() {
      // returns array of sections that should be hidden because condition not true
      var conditions = {
        "change-shop": this.hasMultipleShops,
        // "tuk-support": false,
      };
      return Object.keys(conditions)
        .map((k) => {
          if (!conditions[k]) return k;
        })
        .filter((k) => k);
    },
    filteredSections() {
      if (this.$store.getters.isSuperUser) return this.sections; // show superusers all
      // otherwise filter out superuser sections and hidden sections
      return this.sections.filter((s) => {
        return (
          !this.superOnly.includes(s.name) &&
          !this.hideSections.includes(s.name)
        );
      });
    },
    roleBusinessID() {
      if (!this.$store.getters.getCommerceAgentRole) return null;
      return this.$store.getters.getCommerceAgentRole.business.id;
    },
    businessID() {
      if (!this.id) return this.roleBusinessID;
      return this.id;
    },
    // business() {
    //   console.log("z", this.z);
    //   // if (!this.$store.getters.getCommerceAgentRole) return null;
    //   // return this.$store.getters.getCommerceAgentRole.business;
    //   return this.$store.state.selectedBusiness;
    // },
    data() {
      return this.business.data;
    },
    commerce() {
      if (!this.business || !this.business.workflows) return null;
      return this.business.workflows.find((w) => w.name === "Commerce");
    },
    commerceRoles() {
      return this.$store.state.roles.filter(
        (r) => r.role_name === "Commerce Agent" // probably use "Commerce Manager"
      );
    },
    hasMultipleShops() {
      return this.commerceRoles.length > 1 || this.$store.getters.isSuperUser;
    },
    bannerStyle() {
      return this.business.data.banner_style;
    },
    hideTukExpress() {
      if (!this.commerce.data.tuk_express) return false;
      return this.commerce.data.tuk_express.hide;
    },
    userName() {
      var name = this.$store.getters.realName;
      if (!name) return null;
      if (name.length < 10) return name;
      name = name.split(" ")[0];
      if (name.length < 10) return name;
      return this.shortenString(name, 10);
    },
    showDeleted() {
      return this.business.is_deleted && this.showDeletedBtn;
    },
    isOpen() {
      if (this.isPaused || this.closedUntil) return false;
      if (this.data.hours_type === "always-open") return true;
      if (!this.data.hours) return true; // unknown hours, say open
      var today = this.$date.getShortDay(); //new Date().toLocaleString("en-US", { weekday: "short" });
      var hours = this.data.hours[today.toLowerCase()];
      if (hours && this.openNow(hours)) return true;
      return false;
    },
    closedUntil() {
      if (!this.commerce || !this.commerce.data.closed_until) return null;
      return this.isFutureTime(this.commerce.data.closed_until);
    },
    closedUntilString() {
      var dateString = this.$h.shortDate(this.commerce.data.closed_until);
      return `closed until ${dateString}`;
    },
    hoursAlwaysOpen() {
      if (!this.business.data.hours_type) return true; // default
      return this.business.data.hours_type === "always-open";
    },
    isPaused() {
      if (!this.commerce) return false;
      return this.commerce.data.paused;
    },
    profilePic() {
      if (this.business.profile_pic_url) return this.business.profile_pic_url;
      return "https://i.ibb.co/DK0f6y3/TUK-Esssentials-profile.png"; // ../assets/home_menu_shop.png
    },
    bannerPicURL() {
      if (this.business.banner_pic_url) return this.business.banner_pic_url;
      return `https://www.khaosodenglish.com/wp-content/uploads/2019/02/DSC06061.jpg`;
    },
    themeBgColor() {
      console.log("z", this.z);
      var bgColor = this.business.data.theme_color;
      if (!bgColor) return null;
      return `background-color: ${bgColor}`;
    },
    themeColor() {
      console.log("z", this.z);
      var bgColor = this.business.data.theme_color;
      if (!bgColor) return null;
      return `color: ${this.$h.textColor(bgColor)}`;
    },
  },
  mounted() {
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") {
        // this.updateOrdersCommerceAgent();
      }
    });
    this.init();
  },
  activated() {
    this.init();
  },
  methods: {
    init() {
      this.checkVersion();
      // check if they have the correct role to view this page
      if (!this.hasPermission()) return; // will call goHome if not allowed

      this.console("businessID", this.businessID); // either param ID or active role

      this.clearURLQuery();
      // if (this.$route.path !== this.$route.fullPath) this.$router.replace(this.$route.path); // clear the query

      this.$store.commit("selectBusiness", this.businessID);

      // update business and workflows everytime
      this.refreshBusiness();
      // this.$store
      //   .dispatch("getAndSelectBusiness", this.businessID)
      //   .then(() => {
      //     this.setMetaThemeColor();
      //     this.z += 1;
      //   })
      //   .catch((err) => this.apiError(err));
      // this.$store
      //   .dispatch("getWorkflows", this.businessID)
      //   .catch((err) => this.apiError(err));

      this.triggerProfilePic();

      this.loading = true;
      setTimeout(() => (this.loading = false), 5000);
    },
    refreshBusiness() {
      this.$store
        .dispatch("getAndSelectBusiness", this.businessID)
        .then((res) => {
          console.log("refreshBusiness", res.data);
          if (!this.business) {
            this.business = res.data;
          } else if (this.businessUpdated(res.data)) {
            this.business = null;
            this.$nextTick(() => (this.business = res.data));
          } // else this.infoToast("Same!");
        })
        .catch((err) => this.apiError(err));
    },
    businessUpdated(b) {
      if (this.business.updated_at !== b.updated_at) return true;
      var c = b.workflows.find((w) => w.name === "Commerce");
      if (c && this.commerce.updated_at !== c.updated_at) return true;
      return false;
    },
    skipName() {
      this.shopName = this.business.name.slice(0, -1); // remove the *
      this.saveShopName();
      var msg = `You can change your shop's name<br>in the Business Info section.`;
      this.infoToast(msg, "bottom", 8000);
    },
    saveShopName() {
      if (!this.shopName || this.shopName.length < 5) {
        var msg = "Shop name is too short";
        this.errorToast(msg, "top");
        return;
      }
      if (this.shopName.includes("*")) {
        msg = "Shop name cannot contain [ * ]";
        this.errorToast(msg, "top");
        return;
      }
      this.updatingShopName = true;
      var obj = { id: this.business.id, name: this.shopName };
      this.$store
        .dispatch("updateBusiness", obj)
        .then((res) => {
          this.console("saveShopName success", res);
          this.business.name = this.shopName; // set it locally
          this.successToast("Updated Shop Name");
        })
        .catch((err) => this.apiError(err))
        .finally(() => (this.updatingShopName = false));
    },
    skipTutorial() {
      this.showTutorial = false;
      this.$confirm({
        message: `You can access this Onboarding Tutorial from the Examples and Tutorials section.`,
        button: {
          yes: "Okay",
        },
      });
    },
    hasPermission() {
      if (this.isSuperUser()) return true; // allowed
      if (this.$store.state.roles) {
        var roles = this.$store.state.roles;
        var valid = roles.find(
          (r) =>
            r.role_name === "Commerce Agent" &&
            r.business_id === this.businessID
        );
        if (valid) return true; // allowed
        if (this.roleBusinessID) {
          this.goto(`/commerce_home/${this.roleBusinessID}`); // go to the right biz id
          return false;
        }
      }
      this.infoToast("Login to view this page", "top", 9000);
      // this.goHome(); // not allowed, go hom
      this.goto("/business_login");
      return false;
    },
    setMetaThemeColor() {
      var color = this.business.data.theme_color || "gold";
      document.querySelector("meta[name='theme-color']").content = color;
    },
    onScroll() {
      if (!this.$refs.scrollable) return;
      this.scrollPos = this.$refs.scrollable.scrollTop;
      // this.rectangleHeight = 473 + scrollTop;
      if (this.scrollPos > 150) this.isScrollTop = true;
      else this.isScrollTop = false;
    },
    triggerProfilePic() {
      console.log("triggerProfilePic", this.scrollPos);
      if (this.scrollPos === 0) return;
      if (this.scrollPos > 1) {
        this.$refs.scrollable.scrollTo({ top: this.scrollPos });
        return;
      }
      this.scrollPos = 1;
      setTimeout(() => (this.scrollPos = 0), 100);
    },
    scrollToTop() {
      this.$refs.scrollable.scrollTo({ top: 0, behavior: "smooth" });
    },
    viewShop() {
      this.goto(`/shop/${this.businessID}?tab=info`);
    },
    triggerDelivery() {
      this.goto(`express/${this.businessID}?tab=promos&agent=true`);
    },
    forceUpdateApp() {
      this.clearCacheAndReload();
    },
    openHours() {
      if (this.isPaused || this.closedUntil) {
        this.goto("/commerce_page/set-hours");
        return;
      }
      // day of week
      var d1 = this.$t("dow.mon");
      var d2 = this.$t("dow.tue");
      var d3 = this.$t("dow.wed");
      var d4 = this.$t("dow.thu");
      var d5 = this.$t("dow.fri");
      var d6 = this.$t("dow.sat");
      var d7 = this.$t("dow.sun");

      // text if Always Open
      var txt = this.$t("always-open");
      var hours = `
<tr><td>${d1}:</td><td>${txt}</td></tr>
<tr><td>${d2}:</td><td>${txt}</td></tr>
<tr><td>${d3}:</td><td>${txt}</td></tr>
<tr><td>${d4}:</td><td>${txt}</td></tr>
<tr><td>${d5}:</td><td>${txt}</td></tr>
<tr><td>${d6}:</td><td>${txt}</td></tr>
<tr><td>${d7}:</td><td>${txt}</td></tr>`;

      if (!this.hoursAlwaysOpen) {
        // hours for Selected Hours
        var mon = this.data.hours.mon || this.$t("shop.closed");
        var tue = this.data.hours.tue || this.$t("shop.closed");
        var wed = this.data.hours.wed || this.$t("shop.closed");
        var thu = this.data.hours.thu || this.$t("shop.closed");
        var fri = this.data.hours.fri || this.$t("shop.closed");
        var sat = this.data.hours.sat || this.$t("shop.closed");
        var sun = this.data.hours.sun || this.$t("shop.closed");
        hours = `
<tr><td>${d1}:</td><td>${mon}</td></tr>
<tr><td>${d2}:</td><td>${tue}</td></tr>
<tr><td>${d3}:</td><td>${wed}</td></tr>
<tr><td>${d4}:</td><td>${thu}</td></tr>
<tr><td>${d5}:</td><td>${fri}</td></tr>
<tr><td>${d6}:</td><td>${sat}</td></tr>
<tr><td>${d7}:</td><td>${sun}</td></tr>`;
      }
      var html = `
<p style='text-align:left; font-size:1.2em; margin-bottom:10px'>
<i class='far fa-clock'></i>&nbsp;Shop Hours</p>
<div class='hours-modal'><table><tbody>${hours}</tbody></table></div>
`;
      this.$swal({
        showCloseButton: true,
        html: html,
        confirmButtonText: "Edit Hours",
      }).then((val) => {
        if (val.value) this.goto("/commerce_page/set-hours");
      });
    },
    openCommerceManagerAlerts() {
      this.infoToast("Manager alerts coming soon", "top");
    },
    defaultImg(e) {
      e.target.src = this.$store.state.menuItemPlaceholderPic;
    },
  },
};
</script>

<style scoped>
.commerce-home {
  height: 100vh;
  overflow: hidden;
  text-align: left;
  max-width: 600px;
}
.wrapper {
  height: 100vh;
  overflow: scroll;
}
.top-bar {
  position: absolute;
  top: 0;
  height: 56px;
  width: 100vw;
  max-width: 600px;
  background-color: rgb(59, 59, 59);
  /* background-color: #ddd; */
  z-index: 1;
}
.top-bar p {
  margin-left: 60px;
  margin-top: 15px;
  font-size: 1.1em;
  font-weight: 500;
  max-width: calc(100vw - 108px);
  /* color: lightgoldenrodyellow; */
  color: gainsboro;
  white-space: nowrap;
  overflow: auto;
}
.app-version {
  padding: 20px 10px;
  color: grey;
  font-size: 0.8em;
  font-weight: 500;
  margin-bottom: 60px;
}
.has-bg-img {
  /* background: url("../assets/NYC.jpg") center center; */
  background-color: #2693da;
  background-size: cover;
  background-position: center;
  height: 200px; /* height: 25vh; */
}
.welcome {
  padding: 12px;
  /* width: 100vw; */
}
/* .welcome p {
  max-width: calc(100vw - 100px);
} */
.divider {
  height: 8px;
}
.icon {
  color: grey;
  width: 24px;
  margin-right: 8px;
  padding-top: 4px;
  text-align: center;
}
.order-summary {
  margin: 0 12px;
  margin-top: -4px;
  font-weight: 500;
  color: grey;
}
.tag.skip {
  border: 1px solid #aaa;
  background-color: rgba(255, 255, 255, 0.3);
  color: #555;
  font-weight: 450;
  border-radius: 20px;
}
.gradient {
  padding-top: 20px !important;
  background-image: linear-gradient(
    to bottom,
    transparent,
    rgba(0, 0, 0, 0.3) 20%,
    rgba(0, 0, 0, 0.8)
  );
}
.business-name {
  font-size: 1.2em;
  font-weight: 500;
  padding: 4px 10px;
  text-shadow: 0 0 3px black;
  text-align: left;
  color: white;
  max-width: calc(100vw - 100px);
}
.alerts {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 2;
}
.shadow {
  filter: drop-shadow(1px 1px 1px black);
}
.button.shadow {
  background-color: rgba(0, 0, 0, 0.2);
}
.deleted-bg {
  position: absolute;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 0, 0, 0.14);
}
.deleted-btn {
  padding: 12px;
  background-color: red;
  color: white;
  /* margin: auto; */
  width: 50vw;
  top: 50vh;
  position: absolute;
  transform: translate(50%, -50%);
  border-radius: 100px;
  box-shadow: 1px 1px 5px black;
  font-size: 1.8em;
}
.bottom {
  position: absolute;
  bottom: 0;
  height: 60px;
  width: 100%;
  max-width: 600px;
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(5px);
  padding-bottom: 20px;
  padding-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
  z-index: 3;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  font-size: 0.9em;
  text-align: center;
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.35);
  clip-path: inset(-3px 0px 0px 0px);
}
.bottom .column {
  flex: 1;
  display: inline-block;
  /* width: 74px; */
  padding: 0 0;
  cursor: pointer;
}
.column i {
  color: grey;
}
.profile-pic {
  position: absolute;
  top: 150px;
  right: 14px;
  border-radius: 100px;
  object-fit: cover;
  height: 90px;
  width: 90px;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.7), 0px 0px 5px rgba(0, 0, 0, 0.4);
  z-index: 1;
  transition: all 0.9s ease;
  border: 1px solid black;
  cursor: pointer;
}
@media only screen and (min-width: 600px) {
  .profile-pic {
    right: initial;
    left: calc(600px - 104px);
  }
  .pp-high {
    right: initial;
    left: calc(600px - 56px);
  }
  .alerts {
    right: initial;
    left: calc(600px - 50px);
  }
}
.pp-high {
  transition: all 0.6s ease;
  top: 0;
  /* left: calc(100vw - 66px); */
  right: 0;
  border-radius: 0;
  height: 56px;
  width: 56px;
  box-shadow: 0 0 0 white;
  border: 0px;
  /* opacity: 0.8; */
}
.fa-user-secret {
  margin-bottom: 24px;
  font-size: 5em;
  color: #ccc;
}
.row {
  background-color: white;
  padding: 8px;
  cursor: pointer;
}
.hours {
  text-shadow: 0 0 1px black, 0 0 3px white, 0 0 3px white;
  font-weight: 500;
  background-color: rgba(255, 255, 255, 0.7);
  border-radius: 3px;
  padding: 1px 4px;
  margin-left: 2px;
}
.tile {
  background-size: contain;
}
.tutorial-icon {
  padding: 0 6px;
  font-size: 0.8em;
  background-color: white;
  border: 1px solid #bbb;
  color: grey;
  font-weight: 500;
  border-radius: 20px;
  text-align: center;
  margin-right: 6px;
}
.tutorial .button {
  margin-top: 8px;
  /* margin-left: 32px; */
  margin-bottom: 12px;
  /* width: 280px; */
  width: 320px;
}
.tutorial .button p {
  width: 100%;
  text-align: left;
  display: table;
}
.tutorial .button p > i {
  display: table-cell;
  vertical-align: middle;
  text-align: right;
}
.iframe-wrapper {
  position: absolute;
  right: 0;
  width: calc(100vw - 600px);
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.desktop-preview {
  width: 100vw;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(3px);
}
.desktop-preview .shop-profile {
  height: calc(100vh - 100px);
  /* max-width: initial; */
  max-width: calc(100vw - 100px);
}
.desktop-preview .preview-btn {
  top: 12px;
}
.smartphone-bg {
  background-image: url(/img/home2/smartphone.svg);
  background-repeat: no-repeat;
  background-position: center;
  opacity: 0.5;
}
.smartphone-bg p {
  margin: 30px;
  padding: 20px;
  background-color: white;
  border-radius: 4px;
  text-align: center;
}
.shop-profile {
  flex: 1;
  padding: 10px;
  margin: 10px;
  /* margin-top: 10px; */
  height: calc(100vh - 20px);
  /* width: calc(100vw - 600px); */
  width: 100%;
  max-width: 550px;
  border-radius: 20px;
  box-shadow: 0 0 5px black;
  background-color: #333;
}
.preview-btn {
  position: absolute;
  top: 2px;
  background-color: white;
  border-radius: 8px;
  padding: 2px 6px;
  box-shadow: 0 0 4px black;
  font-weight: 500;
  color: grey;
  cursor: pointer;
}
.preview-btn .fa {
  background-color: #eee;
  border-radius: 20px;
  padding: 3px;
  color: #444;
  /* border: 1px solid grey; */
  box-shadow: 0 0 1px grey;
}
.preview-btn .fa:hover {
  background-color: yellow;
  border: 1px solid white;
}
.pulse-input {
  animation: shadow-pulse-gold 2s ease-out infinite;
}
/* rgba(255, 255, 0, 1) */
@keyframes shadow-pulse-gold {
  0% {
    box-shadow: inset 0 0 0 0px lightgreen;
  }
  50% {
    box-shadow: inset 0 0 0 6px rgba(144, 238, 144, 0.7);
  }
  100% {
    box-shadow: inset 0 0 0 0px lightgreen;
  }
}
</style>

////////////////////////////// swal global style /////////////////////////////
<style>
.hours-modal td {
  padding: 5px;
}
</style>